import { type RefObject, useLayoutEffect, useState } from "react";

/** Reflow to readable records when the actual content width cannot fit the enlarged text. */
export function useReadableWidth(
  ref: RefObject<HTMLElement | null>,
  minRem: number,
  active = true,
): boolean {
  const [compact, setCompact] = useState(false);
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element || !active) return;
    const measure = () => {
      const width = element.getBoundingClientRect().width;
      const rootSize = Number.parseFloat(getComputedStyle(document.documentElement).fontSize);
      if (width > 0 && rootSize > 0) setCompact(width < minRem * rootSize);
    };
    measure();
    const resize = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(measure);
    resize?.observe(element);
    const root = new MutationObserver(measure);
    root.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class", "style"],
    });
    window.addEventListener("resize", measure);
    return () => {
      resize?.disconnect();
      root.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [active, minRem, ref]);
  return compact;
}
